export const HINDI = {
  'language': 'Hindi',
  'amount': {
    'placeholder': 'आप कितना धन जुटाना चाहते हैं?',
    'error': {
      'min': 'न्यूनतम लक्ष्य राशि ₹ 2000 है!',
      'max': 'अधिकतम लक्ष्य राशि ₹ 5 करोड़ हो सकती है',
      'required': 'न्यूनतम लक्ष्य राशि ₹ 2000 है!'
    },
    'hint': 'न्यूनतम ₹ 2000 होना चाहिए',
    'popover': {
      'title': 'लक्ष्य',
      // tslint:disable-next-line:max-line-length
      'desc': `आप अपनी लक्ष्य राशि को बाद में बदल सकते हैं। यदि आप सुनिश्चित नहीं हैं कि कहां से शुरू करना है, तो अधिकांश अभियानों में ₹ 1,00,000 का एक लक्ष्य है।`,
      'eg': 'लक्ष्य ₹ 2000 से बड़ा होना चाहिए'
    }
  },
  'title': {
    'placeholder': 'अपने फंडरेसर का शीर्षक लिखें',
    'error': {
      'minlength': 'फंडरेसर शीर्षक 5-75 अक्षरों के बीच होना चाहिए',
      'maxlength': 'फंडरेसर शीर्षक 5-75 अक्षरों के बीच होना चाहिए',
      'required': 'फंडरेसर शीर्षक 5-75 अक्षरों के बीच होना चाहिए'
    },
    'popover': {
      'title': 'यह आपके फंडरेसर का शीर्षक ह',
      'desc': 'जैसे कम उम्र की बालिकाओं को सशक्त बनाने में हमारी मदद करें या हमारी आस्था को कैंसर से लड़ने में मदद करें!'
    }
  },
  'relation': {
    'placeholder': 'आप किसके लिए धन जुटा रहे हैं?',
    'popover': {
      'title': 'आप किसके लिए फंड जुटा रहे हैं',
      'desc': 'आप पर्सनल, क्रिएटिव या एनजीओ के लिए अभियान बना सकते हैं'
    },
    'error': {
      'required': 'कृपया एक वैध विकल्प चुनें'
    }
  },
  'name': {
    'placeholder': `मरीज का पूरा नाम`,
    'error': {
      'maxlength': 'नाम 50 अक्षरों से अधिक नहीं होना चाहिए',
      'pattern': 'कृपया कोई मान्य नाम दर्ज करें',
      'required': 'कृपया कोई मान्य नाम दर्ज करें'
    },
    'hint': 'मरीज के आधार कार्ड में लिखित नाम',
    'popover': {
      'title': `मरीज का नाम`,
      'desc': 'कृपया उनके आधार कार्ड में उल्लिखित रोगी का पूरा नाम दर्ज करें'
    }
  },
  'patient': {
    'placeholder': `मरीज का पूरा नाम`,
    'error': {
      'maxlength': 'नाम 50 अक्षरों से अधिक नहीं होना चाहिए',
      'minlength': 'कृपया उनके आधार कार्ड में उल्लिखित रोगी का पूरा नाम दर्ज करें',
      'pattern': 'कृपया कोई मान्य नाम दर्ज करें',
      'required': 'कृपया कोई मान्य नाम दर्ज करें'
    },
    'hint': 'मरीज के आधार कार्ड में लिखित नाम',
    'popover': {
      'title': `मरीज का नाम`,
      'desc': 'कृपया उनके आधार कार्ड में उल्लिखित रोगी का पूरा नाम दर्ज करें'
    }
  },
  'age': {
    'placeholder': `मरीज की उम्र`,
    'error': {
      'required': 'कृपया एक मान्य आयु समूह दर्ज करें'
    }
  },
  'uploadImg': {
    'error': {
      'required': 'जवाब आवश्यक है',
      'pattern': 'कृपया एक सही नंबर दर्ज करें'
    }
  },
  'hosptialisationStatus': {
    'placeholder': `अस्पताल में भर्ती होने की स्थिति`,
    'error': {
      'required': 'जवाब आवश्यक है'
    }
  },
  'cause': {
    'placeholder': 'कृपया उद्देश्य चुनें',
    'popover': {
      'title': 'यह आपका कारण है',
      'desc': 'यह समान विचारधारा वाले लोगों की मदद करने के लिए है, दयालु लोग हमारी वेबसाइट पर आपका फंडराइज़र ढूंढते हैं।'
    },
    'error': {
      'required': 'कृपया उद्देश्य चुनें'
    }
  },
  'survey': {
    'placeholder': 'आपने पहली बार केटो के बारे में कैसे सुना?',
    'error': {
      'required': 'जवाब आवश्यक है'
    }
  },
  'end_date': {
    'placeholder': 'अंतिम तिथि',
    'error': {
      'minlength': 'फंडरेसर अंतिम तिथि आज से पुरानी नहीं हो सकती है!',
    },
    'popover': {
      'title': 'फंडरेसर अंतिम तिथि',
      'desc': 'आपका फंडरेसर इस तारीख को समाप्त हो जाएगा।'
    }
  },
  'fundraiser_image': {
    'placeholder': 'चित्र / वीडियो जोड़ें',
    'optional': '(वैकल्पिक)',
    'upload': 'अपलोड करें',
    'popover': {
      'title': 'चित्र अपलोड करें।',
      'desc': `यह आपके फंडरेसर का पहला पृष्ठ है। तस्वीरें आपको अधिक धन जुटाने में मदद करेंगी। ऐसे स्पष्ट चित्र / वीडियो अपलोड करें, जो आपके फंडरेसर का सबसे अच्छा वर्णन करते हैं।`,
      'eg': ` आदर्श आकार: 750x435 px। यदि चित्र बड़ा है, तो चिंता न करें, अपलोड करते समय आप इसे छोटा कर सकते हैं।`
    }
  },
  'beneficiary_image': {
    'placeholder': `Add Patient's Image`,
    'popover': {
      'title': 'This is the person whom you are raising money for.',
      'desc': `Adding an image increase contributions by 50%.
                 We may request additional information from you to verify that the funds raised will go to this beneficiary.`
    }
  },
  'short_description': {
    'placeholder': 'वर्णन करें',
    'error': {
      'minlength': 'न्यूनतम 10 अक्षर आवश्यक है',
      'maxlength': 'वर्णन में 120 से अधिक अक्षर नहीं होने चाहिए'
    },
    'popover': {
      'title': 'Explain your fundraiser in short',
      'desc': `Write a short blurb for your fundraiser in 120 characters.`,
      'eg': `E.g. Aastha is only 8 years old, support her fight against Acute Lymphoblastic Leukemia`
    }
  },
  'description_story': {
    'placeholder':
      'एक कहानी लिखें जो आपके कारण के साथ न्याय करती है और समर्थक को दान बटन पर क्लिक करती है।'
      + '\n\nइन सुझावों का पालन करें-'
      + '\n* इस बारे में बताएँ कि आप किसके लिए धन जुटा रहे हैं।'
      + '\n* अपने समर्थकों को बताएं कि आपने किस कारण के लिए फंडरेसर शुरू किया है ताकि वे योगदान करने के लिए प्रेरित हों।'
      + '\n* अपने समर्थकों से एक अपील करें।',
    'popover': {
      'title': 'हमें अपने फंडरेसर के बारे में अधिक बताएं',
      'desc': 'अपनी कहानी बताएं',
      'placeholder':
        `<div class="hindi14 mb-4">अपने फंडरेसर के संदर्भ का वर्णन करें ताकि आपको समर्थन मिले।</div>
            <div class="hindi14 mb-4">इन सुझावों का पालन करें-</div>
            <div class="hindi14 mb-4">इस बारे में बताएँ कि आप किसके लिए धन जुटा रहे हैं।</div>
            <div class="hindi14 mb-4">अपने समर्थकों से एक अपील करें।</div>
            <div class="hindi14 mb-4">अपने समर्थकों से निवेदन करें।</div>
            <div class="hindi14 mb-4">अपने समर्थकों को बताएं कि आपने किस कारण के लिए फंडरेसर शुरू किया है ताकि वे योगदान करने के लिए प्रेरित हों।</div>
            <div class="hindi14 mb-4">अपने समर्थकों को पूरी जानकारी दें कि उनके योगदान का उपयोग कैसे किया जाएगा।</div>`,
    }
  },
  'disease': {
    'placeholder': 'बीमारी',
    'error': {
      'required': 'कृपया एक बीमारी का चयन करें'
    }
  },
  'hospital': {
    'placeholder': 'अस्पताल',
    'error': {
      'required': 'कृपया एक अस्पताल चुनें'
    }
  },
  'ngo': {
    'placeholder': 'एनजीओ का नाम',
    'error': {
      'notFound': 'इस नाम के साथ कोई एनजीओ नहीं मिला है'
    },
    'popover': {
      'title': 'एनजीओ',
      'desc': 'एनजीओ'
    }
  },
  'city': {
    'placeholder': 'अपने शहर का नाम लिखें',
    'popover': {
      'title': 'अपना फंडरेसर शहर दर्ज करें',
      'desc': 'यह वह शहर है जिसमें यह फंडरेसर चलेगा'
    }
  },
  'beneficiaryname': {
    'placeholder': 'लाभार्थी का नाम',
    'error': {
      'maxlength': 'लाभार्थी का नाम 50 अक्षरों से अधिक नहीं होना चाहिए',
      'pattern': 'कृपया लाभार्थी का नाम दर्ज करें',
      'required': 'कृपया लाभार्थी का नाम दर्ज करें'
    },
    'popover': {
      'title': 'जिनके लिए आप धन जुटा रहे हैं उनका नाम।',
      'desc': 'अपने समर्थकों को यह सूचित करना महत्वपूर्ण है कि आप किसके लिए धन जुटा रहे हैं।'
    }
  },
  'names': {
    'placeholder': 'नाम',
    'hint': 'जैसा कि आपके आधार कार्ड में बताया गया है',
    'error': {
      'maxlength': 'अधिकतम वर्ण सीमा पार हो जाती है',
      'pattern': 'कृपया कोई मान्य नाम दर्ज करें'
    },
  },
  'email': {
    'placeholder': 'ईमेल',
    'error': {
      'email': 'कृपया अपना मान्य ईमेल लिखें',
    },
  },
  'password': {
    'placeholder': 'पासवर्ड',
    'error': {
      'minlength': 'कृपया न्यूनतम 8 वर्ण दर्ज करें',
      'pattern': 'कम से कम 1 संख्या, 1 अपरकेस और 1 लोअरकेस अक्षर आवश्यक है'
    }
  },
  'mobile': {
    'placeholder': 'मोबाइल',
  },
  'reward_title': {
    'placeholder': 'Reward Title',
    'error': {
      'minlength': 'Minimum 5 characters required',
      'maxlength': 'Reward Title should not exeeds 50 characters'
    },
    'popover': {
      'title': 'Enter Reward Title',
      'desc': 'Put an apealing reward title'
    }
  },
  'guardian_relations': {
    'Friend': {
      'Below 5 years': 'अभिभावक मोबाइल नंबर',
      '6 -10 years': 'अभिभावक मोबाइल नंबर',
      '11 - 17 years': 'अभिभावक मोबाइल नंबर',
      '18 - 30 years': 'मरीज का मोबाइल नंबर',
      '30 - 40 years': 'मरीज का मोबाइल नंबर',
      'Above 40 years': 'मरीज का मोबाइल नंबर'
    },
    'Friend\'s Family': {
      'Below 5 years': 'अभिभावक मोबाइल नंबर',
      '6 -10 years': 'अभिभावक मोबाइल नंबर',
      '11 - 17 years': 'अभिभावक मोबाइल नंबर',
      '18 - 30 years': 'मरीज का मोबाइल नंबर',
      '30 - 40 years': 'मरीज का मोबाइल नंबर',
      'Above 40 years': 'मरीज का मोबाइल नंबर'
    },
    'Colleague': {
      'Below 5 years': 'अभिभावक मोबाइल नंबर',
      '6 -10 years': 'अभिभावक मोबाइल नंबर',
      '11 - 17 years': 'अभिभावक मोबाइल नंबर',
      '18 - 30 years': 'मरीज का मोबाइल नंबर',
      '30 - 40 years': 'मरीज का मोबाइल नंबर',
      'Above 40 years': 'मरीज का मोबाइल नंबर'
    },
    'Relative': {
      'Below 5 years': 'अभिभावक मोबाइल नंबर',
      '6 -10 years': 'अभिभावक मोबाइल नंबर',
      '11 - 17 years': 'अभिभावक मोबाइल नंबर',
      '18 - 30 years': 'मरीज का मोबाइल नंबर',
      '30 - 40 years': 'मरीज का मोबाइल नंबर',
      'Above 40 years': 'मरीज का मोबाइल नंबर'
    },
    'Legal ward': {
      '18 - 30 years': 'मरीज का मोबाइल नंबर',
      '30 - 40 years': 'मरीज का मोबाइल नंबर',
      'Above 40 years': 'मरीज का मोबाइल नंबर'
    }
  },
  'otp': {
    'placeholder': `OTP`,
    'error': {
      'required': 'कृपया OTP दर्ज करें'
    }
  },
  get_otp: 'OTP भेजें',
  verify_mobile: 'मोबाइल नंबर की पुष्टि करें',
  start_your_fundraiser: 'अपना फंडरेसर शुरू करें',
  change_easily: 'आप किसी भी समय अपने फंडरेसर में आसानी से बदलाव कर सकते हैं',
  tell_us_more: 'हमें अपने फंडरेसर के बारे में अधिक बताएं',
  tellAboutFundraiser: 'हमें अपने फंडरेसर के बारे में बताएं',
  patientIsMy: 'मरीज कौन है?',
  raising_funds_for: 'उद्देश्य के लिए धन जुटाना',
  ngo_charity: 'एनजीओ/दान पुण्य',
  qualification: 'आपकी शिक्षा योग्यता',
  occupation: 'आपकी रोजगार स्थिति',
  other: 'अन्य',
  purposeText: 'प्रयोजन',
  change_purpose: 'उद्देश्य बदले',
  save_and_continue: 'सहेजें और जारी रखें',
  ketto_zero_fee: 'केटो प्लेटफ़ॉर्म की शून्य शुल्क नीति आपके लिए अधिक धन सुनिश्चित करती है',
  is_patient_admitted: `क्या मरीज अस्पताल में भर्ती है?`,
  tell_us_about_patient: `हमें मरीज के बारे में बताएं`,
  guardian_no: `अभिभावक मोबाइल नंबर`,
  patient_no: 'मरीज का मोबाइल नंबर',
  yes: `हाँ`,
  no: `नहीं`,
  optional: '(वैकल्पिक)',
  story_form_title: `आप फंडरेसर क्यों चला रहे हैं? इस बारे में बताएं`,
  help_me_write_this: `लिखने में मदद करें`,
  terms_of_use: `उपयोग की शर्तें`,
  privacy_policy: `गोपनीयता नीति`,
  plans_and_pricing: `मूल्य निर्धारण`,
  choose_file: 'फ़ाइल का चयन',
  submit_for_approval: 'अनुमोदन के लिए सबमिट करें',
  start_your_fr: 'अपना फंडरेसर शुरू करें',
  exisiting_account: 'पहले से खाता है? ',
  login: 'यहां लॉगिन करें',
  next: 'आगे',
  purpose: 'धन जुटाने का उद्देश्य',
  are_you_an_ngo: 'क्या आप एक एनजीओ हैं? ',
  apply_here: 'यहां आवेदन करें',
  validPhNo: 'कृपया एक सही मोबाइल नंबर दर्ज करें',
  get_assistance: 'सहायता प्राप्त करें',
  back: 'पीछे',
  fieldRequired: 'जवाब आवश्यक है',
  acknowledge: `मैं स्वीकार और पुष्टि करता हूं कि ऊपर दी गई जानकारी मेरे ज्ञान और विश्वास से सही है| यदि उपरोक्त जानकारी में से कोई भी गलत पाया जाता है तो मैं उत्तरदायी होने के लिए सहमत हूं । मैं इसे नियामक अधिकारियों के साथ साझा करने या इसका खुलासा करने के लिए अनुमति
    देता हूं, जैसा कि कानून द्वारा आवश्यक हो सकता है।`
};
